import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { classNames } from "@/utils/classNames";

import { formatNumber } from "../utils/percentage";
import { KpiKey } from "../utils/kpiFilterMap";

export interface KpiHeroTileProps {
	label: string;
	value: number | undefined;
	sublabel?: string;
	clickKpi?: KpiKey;
	onKpiClick?: (kpi: KpiKey) => void;
	className?: string;
}

export const KpiHeroTile: FunctionComponent<KpiHeroTileProps> = ({
	label,
	value,
	sublabel,
	clickKpi,
	onKpiClick,
	className,
}) => {
	const { t } = useTranslation();
	const clickable = Boolean(clickKpi && onKpiClick);

	const body = (
		<>
			<div className="text-xs text-text-meta uppercase tracking-wide">{label}</div>
			<div className="text-2xl font-semibold text-text tabular-nums mt-1">
				{formatNumber(value)}
			</div>
			{sublabel ? <div className="text-xs text-text-meta mt-0.5">{sublabel}</div> : null}
		</>
	);

	if (clickable) {
		return (
			<button
				aria-label={t("analytics.viewLeadsFor", { kpi: label })}
				className={classNames(
					"flex flex-col items-start text-left rounded-xl border border-border-light bg-brand-white px-4 py-3 min-w-[140px]",
					"hover:border-blue-action hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-action transition-all cursor-pointer",
					className ?? ""
				)}
				type="button"
				onClick={() => clickKpi && onKpiClick && onKpiClick(clickKpi)}
			>
				{body}
			</button>
		);
	}

	return (
		<div
			className={classNames(
				"flex flex-col items-start rounded-xl border border-border-light bg-brand-white px-4 py-3 min-w-[140px]",
				className ?? ""
			)}
		>
			{body}
		</div>
	);
};
